
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3120_55261)","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.906 14.19a6.5 6.5 0 100-13 6.5 6.5 0 000 13z"}}),_c('path',{attrs:{"d":"M6.406 6.19a1.5 1.5 0 111.5 1.5v1M7.906 11.19a.25.25 0 010-.5M7.906 11.19a.25.25 0 000-.5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3120_55261"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.906 .69)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    